class RevisionFormat {

    constructor(){
        return revision => {
        	return moment(revision * 1000).format('DD/MM/YYYY HH:mm:ss');
        };
    }

}

angular.module('cpm')
.filter('revisionFormat', [ () => {
    'use strict';
    return new RevisionFormat();
}]);

